(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lolxi-footer"]) return;
  try {
    
  if (!customElements.get('lolxi-footer-navigation')) {
    customElements.define('lolxi-footer-navigation', class extends HTMLElement {
      // Native named details handle exclusivity; this also supports older browsers.
      #onToggle = (event) => {
        const active = event.target;
        if (!active.matches('.footer-disclosure') || !active.open) return;
        this.querySelectorAll('.footer-disclosure[open]').forEach((details) => {
          if (details !== active) details.open = false;
        });
      };
      connectedCallback() {
        this.addEventListener('toggle', this.#onToggle, true);
      }
      disconnectedCallback() {
        this.removeEventListener('toggle', this.#onToggle, true);
      }
    });
  }
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-lx-cookie-settings]');
    if (!trigger) return;
    const message = trigger.closest('.lx-policy-footer').querySelector('[data-lx-cookie-error]');
    trigger.disabled = true;
    message.hidden = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      message.hidden = false;
    } finally {
      trigger.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
